
<script>
	import listBase from '@_system/components/base/list.vue'
	import jindieform from '@/components/forms/costorder/jindie/form.vue'
	export default {
		extends: listBase,
		name: 'costorderIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'costorder',
				windowName: '费用单',
				windowType: 'modal',
				maindata:null,
				tabledata:null,
				jindierequire:null,
				ids:[],
				list_footerField:[
					{field:'amount',toFixed:2}
				],
			}
		},
		render(h) {
			this.$slots.plug = [
				<jindieform ref = "jindieform" maindata={this.maindata} tabledata={this.tabledata}  onSuccess={this.jindieformSuccess} onClear={this.jindieformClear} />,
			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig,columns,gridOptions){	
				gridOptions.checkboxConfig = null
				columns.forEach((item)=>{
					if(item.field=='reslut'){
						item.slots = {
							default:(params)=>{
								return <div>
											<i style="margin-right:6px;cursor: pointer;font-size:14px" onClick={()=>{this.getStatus(params.row)}} class="el-icon-refresh-left"></i>
											<span>{params.row.reslut?params.row.reslut:''}</span>
										</div>
							}
						}
					}
					if(item.field=='jindietype'){
						item.slots = {
							default: ({row,column}) => {	
								let str= []
								if(row.jindierequire){
									let buff = this.checkjindierequire(row)
									if(buff){
										str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}else{
										str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}
									
								}
								str.push(<span>{column.formatter({row:row})}</span>)
								return str
							}
						}
					}
				})
			},
			checkjindierequire(row){
				let data = row.jindierequire
				let buff = true
				if(row.jindietype == 'CN_BANKTRANSBILL'){
					if(!data.main.FFROMBANKACNTID_FNumber || !data.main.FTOBANKACNTID_FNumber || !data.main.FEXPLANATION){
						buff = false
					}
				}
				if(row.jindietype == 'CN_CASHTRANSBILL'){
					if(!data.main.FOUTCASHACCTID_FNumber || !data.main.FINCASHACCTID_FNumber){
						buff = false
					}
				}
				if(row.jindietype == 'CN_CASHACCESSBILL'){
					if(!data.main.FBillTypeID || !data.main.FBANKACNTID_FNumber || !data.FCashAccount_FNumber){
						buff = false
					}
				}
				if(row.jindietype == 'AP_PAYBILL' || row.jindietype == 'AP_REFUNDBILL'){
					if(!data.costorder_detail || !data.costorder_detail.length){
						buff = false
					}
					data.costorder_detail.forEach((item)=>{
						if(!item.FPURPOSEID_FNumber || !item.FSETTLETYPEID_FNumber){
							buff = false
						}
					})
					if(!data.main.FACCOUNTID_FNumber || !data.main.FCONTACTUNITTYPE || !data.main.FCONTACTUNIT_FNumber){
						buff = false
					}
				}
				return buff
			},
			batchreauditVerify(data){
				return new Promise((reslove,reject)=>{
					let buff = true
					data.forEach((item)=>{
						if(item.flowstatus!=2){
							buff = false
						}
					})
					if(!buff){
						reject('仅允许审核【无流程】单据')
					}else{
						reslove()
					}
					
				})
			},
			batchaudit(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let buff = true
				data.forEach((item)=>{
					if(item.flowstatus!=2){
						buff = false
					}
				})
				if(!buff){
					this.$message.error('仅允许审核【无流程】单据')
					return
				}
				let promisearr = []
				data.forEach((item)=>{
					promisearr.push(
						new Promise((reslove)=>{
								this.$api.module.reaudit(window.config.app, this.moduleName, {
									id: item.id,
									type: 'reaudit'
								}).then(() => {
									reslove()
								},()=>{
									reslove()
								})
						})					
					)})
				this.loading = true
				Promise.all(promisearr).then(()=>{
					this.loading = false
					this.$message.success('操作成功')
					this.customreload()
				},()=>{
					this.loading = false
					this.customreload()
				})
			},

			getStatus(row){
				//console.log(row)
				let handle = this.$loading()
				this.$api.costorder.status({
					id: row.id,
					code: row.code,
					type: 'FY'
				}).then((res) => {
					row.reslut = res
					this.$loadingclose(handle)
				},()=>{
					this.$loadingclose(handle)
				})
			},
			jindieconfig(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let groupBybankAcc = this.$Lodash.groupBy(data,'bankAcc')
				if(Object.keys(groupBybankAcc).length > 1){
					this.$message.error('付款账号必须一致')
					return
				}
				let groupByAmount = this.$Lodash.countBy(data,(item) => {
					if (parseFloat(item.amount) >= 0){
						return 1
					}else{
						return -1
					}
				})
				if(Object.keys(groupByAmount).length > 1){
					this.$message.error('收支方向必须一致')
					return
				}
				
				
				this.loading = true
				let ids = data.map((item)=>{
					return item.id
				})
				this.ids = ids
				this.$api[this.moduleName].initjindiedata({ids:ids}).then((res)=>{
					if(res){
						this.createJindieData(res)
					}					
					this.loading = false
					//this.customreload()
				},()=>{
					this.loading = false
				})
				
				
				
				// data.forEach((item)=>{
				// 	this.$api[this.moduleName].sendwln({id:item.id}).then(()=>{
				// 		this.loading = false
				// 		this.customreload()
				// 	},()=>{
				// 		this.loading = false
				// 	})
				// })
			},
			createJindieData(res){
				let maindata = {}
				maindata.bankAcc = res[0]['bankAcc']
				maindata.jindietype = res[0]['amount'] >=0 ? 'AP_PAYBILL' : 'AP_REFUNDBILL'
				let fullData = res
				let costordertype = window.systemData.emun.filter((item)=>{
					return item.field == 'costordertype'
				})
				let tabledata = fullData.map((item)=>{
					let costordertypecode = null
					let target = costordertype.find((_item)=>{
						return _item.id == item.costordertype
					})
					if(target && target.code){
						costordertypecode = target.code.split('/')[0]
					}
					return {
						mainid:item.mainid,
						id:item.id,
						costordertype:window.systemMethods.getEmunValue('costordertype',item.costordertype),
						costordertypecode:costordertypecode,
						costamount:item.costamount,
						businessdepartmentid:item.businessdepartmentid,
						FEXPENSEDEPTID_E:null,
						FCOSTID:null,
						FSETTLETYPEID:null,
						FPURPOSEID:null,
						F_SXTN_DFKM:null,
						F_SXTN_ZZJG:null,
					}
				})
				tabledata = tabledata.filter((item)=>{
					return item.id
				})
				this.maindata = maindata
				this.tabledata = tabledata
				//console.log(maindata,tabledata)
				this.$nextTick(()=>{
					this.$refs.jindieform.modal_show()
				})
				
			},
			jindieformSuccess(e){
				let sourcedata = JSON.parse(e.data)
				let jindietype = 'AP_PAYBILL'
				//console.log(sourcedata)
				let postdata = []
				this.ids.forEach((item)=>{
					let obj = {}
					let costorder_detail_ids = []
					let costorder_detail = sourcedata.costorder_detail.filter((detail)=>{
						if(detail.mainid == item){
							costorder_detail_ids.push(detail.id)
							return true
						}
						return false						
					})
					let json = JSON.parse(JSON.stringify(sourcedata.json))
					console.log(json)
					if(json.Model.FPAYBILLENTRY){
						json.Model.FPAYBILLENTRY = json.Model.FPAYBILLENTRY.filter((detail)=>{
							return costorder_detail_ids.includes(detail.id)
						})
					}
					if(json.Model.FREFUNDBILLENTRY){
						jindietype = 'AP_REFUNDBILL'
						json.Model.FREFUNDBILLENTRY = json.Model.FREFUNDBILLENTRY.filter((detail)=>{
							return costorder_detail_ids.includes(detail.id)
						})
					}
					obj.main = sourcedata.main
					obj.costorder_detail = costorder_detail
					obj.json = json
					obj.mainid = item
					postdata.push(obj)
				})
				
				
				this.loading = true
				this.$api[this.moduleName].setjindiedata({
						data:postdata,
						jindietype:jindietype,
					}).then(()=>{
					this.customreload()
					this.loading = false
				},()=>{
					this.loading = false
				})
				
				console.log(postdata,1111)
				
			},
			jindieformClear(){
				
			},
		},
		components: {
			
		}
	}
</script>
